/* eslint-disable import/no-anonymous-default-export */
import siteConfig from "../siteConfig";

export default {
  path: "/cookies",
  shortTitle: "Cookies",
  title: "Cookies and browser storage",
  category: "Data and website",
  summary: "What the current React storefront stores locally and what requires a fresh notice before being added.",
  updated: "26 October 2026",
  sections: [
    {
      heading: "Current local storage",
      body: [
        "This React build writes bag and wishlist choices to the browser's localStorage. The record consists of item identifiers, quantities and chosen size and colour, allowing the same browser to restore them after refresh. Source review found no advertising tracker, analytics tag or mailing-list cookie.",
      ],
    },
    {
      heading: "Hosted services",
      body: [
        `Opening the external hosted checkout can cause that service to store technically necessary session or security information under its own notice, including controls aimed at fraud. Because verified provider documentation is not embedded here, ${siteConfig.brandName} does not guess at cookie names, purposes beyond that flow, or expiry periods.`,
      ],
    },
    {
      heading: "Control and consequences",
      body: [
        `Browser settings can erase ${siteConfig.brandName}'s local record. Erasure removes the remembered bag and wishlist on that device; blocking localStorage means those choices may disappear between visits while basic catalog browsing remains possible. On a shared device, clear the record when finished.`,
      ],
    },
    {
      heading: "Future technology",
      body: [
        `Analytics, advertising, preference profiles or cross-site tracking must not be introduced silently. Before adding them, ${siteConfig.brandName} must update this policy and the privacy notice, assess consent and choice requirements, and implement the appropriate control. Questions or requests concerning stored personal data can be emailed to customer care.`,
      ],
    },
  ],
};
